import { routePaths } from "@/shared/config/routePaths";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const LoginPage = lazy(() => import('./LoginPage').then(m => ({ default: m.LoginPage })));

export const authRouter: RouteObject =
{
    path: routePaths.auth, element: <LoginPage />
}